import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import BlockContent from '../SideCart/SC_Content/BlockContent.tsx';
import FreeShippingProgress from '../SideCart/SC_Header/ElementFreeShip.tsx';
import BlockSumFooter from '../SideCart/SC_Footer/BlockSumFooter';
import '../assets/Checkout.css';

function ModulBasket({ store }) {
  const [loading, setLoading] = useState(false);
  const [spinnerloading, setSpinnerLoading] = useState(false);
  const [currentProductId, setCurrentProductId] = useState([]);
  const [currentCartKeyId, setCurrentCartKeyId] = useState([]);

  console.log("Store_all: ", store.getState());
  let currentproducts = store.getState().productdata;
  console.log("Currentproductdata: ", currentproducts);

  return (
    <motion.div
      id="ips-basket-checkoutcart"
      className="ips-checkoutcart-container-right"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={{
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }}
      transition={{ duration: 0.7 }}
    >
      <div className="row g-0 ips-basket-header flex-grow-0 ps-4 pe-4 align-items-center justify-content-center">
        <div className="text-center"><FreeShippingProgress /></div>
      </div>
      <div className="row ips-basket-content flex-grow-1">
        <BlockContent
          store={store}
          loading={loading}
          spinnerloading={spinnerloading}
          currentProductId={currentProductId}
          setCurrentProductId={setCurrentProductId}
          currentCartKeyId={currentCartKeyId}
          setCurrentCartKeyId={setCurrentCartKeyId}
          setLoading={setLoading}
        />
      </div>
      <div className="row g-0 ips-basket-footer flex-grow-0">
        <BlockSumFooter store={store} />
      </div>
    </motion.div>
  );
}

export default ModulBasket;